//@flow

import React from 'react';
import { withRouter } from 'react-router-dom';
import { FlexColumn } from 'styles/Layout';
import styled from 'styled-components';
import SignUpView from 'components/authentication/sign_up/View';
import { IndexTitle } from 'modules/external_tenant/shared/styles';
import { media } from 'styles/Mixins';
import HomeApplication from 'modules/external_tenant/api/actions/HomeApplicationActions';
import HomieContext from 'HomieContext';
import swal from '@sweetalert/with-react';
import { HomeApplicationSteps } from 'modules/agencies/shared/data/CommonData';
import { get } from 'lodash';

const Container = styled(FlexColumn)`
  padding: 30px 15px;
  background-color: #f8f8f8;
  align-items: center;
`;

const Wrapper = styled.div`
  width: 300px;
`;

export const StyledLabel = styled.label`
  color: #747474;
  font-size: 16px;
  line-height: 19px;
  text-align: left;
  font-weight: 500;
  margin-bottom: 12px;
`;

const Title = styled(IndexTitle)`
  margin-bottom: 10px;
  font-size: 20px;
  line-height: 24px;
  min-height: 24px;
  width: 100%;
  max-width: 313px;
  ${media.sm`
    margin-bottom: 16px;
    max-width: 432px;
    font-size: 24px;
    line-height: 29px;
    min-height: 29px;
  `};
`;

const TenantTitle = styled(IndexTitle)`
  font-size: 20px;
  line-height: 24px;
  width: 100%;
  max-width: 313px;
  ${media.sm`
    max-width: 644px;
  `};
`;

const Description = styled.p`
  color: #5a5a5a;
  font-size: 13px;
  line-height: 15px;
  margin: 0 0 20px;
  & .reminder {
    color: #adadad;
    font-size: 12px;
  }
`;

type PropsType = {
  isHomeAppComplete: boolean,
  history: any
};

class FormsSection extends React.Component<PropsType> {
  handleRedirect = (data: any): void => {
    const HaData = {
      home_application: {
        step: 'account',
        external_owner_info: {
          full_name: data.owner_name,
          email: data.owner_email,
          neighborhood: data.neighborhood,
          price: data.price,
          phone_country_code: `+${data.countryCode}`,
          mobile_phone: `+${data.countryCode}${data.externalPhone}`
        }
      }
    };

    HomeApplication.createHomeApplication(
      HaData,
      response => {
        const { id, step } = response.home_application;
        const u_id = get(this.context.currentUser, 'id');

        let translatedStep = HomeApplicationSteps.find(
          ha_step => ha_step.value === step
        );

        translatedStep = translatedStep
          ? translatedStep.label.toLowerCase()
          : '';

        this.context.hideLoadingProcessView();
        this.props.history.push(
          `/inquilinos-externos/${u_id}/aplicaciones/${id}/editar/${translatedStep}`
        );
      },
      error => {
        this.context.hideLoadingProcessView();
        swal({
          title: '¡Ha ocurrido un error!',
          text: error.responseJSON.message,
          icon: 'error',
          timer: 5000
        });
      }
    );
  };

  renderForms = () => {
    if (this.props.isHomeAppComplete) {
      return (
        <TenantTitle>
          Ya recibimos tus datos, pronto tendrás respuesta sobre tu aplicación
          para ser un inquilino Homie
        </TenantTitle>
      );
    }
    return (
      <FlexColumn alignItems="center">
        <Title>
          Llena tu solicitud ahora ¡y descubre lo increíble de ser un inquilino
          Homie!
        </Title>
        <Wrapper>
          <Description>
            Déjanos tus datos y los del inmueble en el que te gustaría vivir, te
            ayudaremos a que sea tu próximo hogar.
            <br />
            <br />
            <span className="reminder">
              Te recordamos que esta promoción no aplica con asesores
              inmobiliarios.
            </span>
          </Description>
          <StyledLabel>Llena tus datos</StyledLabel>
          <SignUpView
            isExternalTenant={true}
            showTerms={true}
            sizeContainer="100%"
            defaultSign={false}
            status={false}
            handleRedirect={this.handleRedirect}
            isResponsive={true}
          />
        </Wrapper>
      </FlexColumn>
    );
  };

  render() {
    return <Container>{this.renderForms()}</Container>;
  }
}

export default withRouter(FormsSection);
FormsSection.contextType = HomieContext;
